import service from '@/services/superaccess'

const camera = {
  state: {
    modal: false,
    test_modal: false
  },
  mutations: {
    updateStatusCameraModal (state, status) {
      state.modal = status
    },
    updateStatusTestCameraModal (state, status) {
      state.test_modal = status
    }
  },
  getters: {
    getStatusCameraModal (context) {
      return context.modal
    },
    getStatusTestCameraModal (context) {
      return context.test_modal
    }
  },
  actions: {
    setStatusCameraModal (context, payload) {
      context.commit('updateStatusCameraModal', payload)
    },
    setStatusTestCameraModal (context, payload) {
      context.commit('updateStatusTestCameraModal', payload)
    },
    addCamera (context, payload) {
      return service.post('/api/camera/create_camera', context, payload)
    },
    modifyCamera (context, payload) {
      return service.post('/api/camera/modify', context, payload)
    },
    inactivateCamera (context, payload) {
      return service.post('/api/camera/inactivate', context, { camera: payload })
    },
    testCamera (context, payload) {
      return service.post('/api/camera/test', context, { id: payload })
    },
    testNewCamera (context, payload) {
      return service.post('/api/camera/test_new', context, payload)
    }
  }
}

export default camera



// WEBPACK FOOTER //
// app/javascript/src/store/camera.js